var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VcLayout',{staticClass:"mainLoader",attrs:{"align-center":"","justify-center":""}},[_c('VcLoader',{attrs:{"color":"#0C315E"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }